import { Injectable, inject } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { Location } from "@angular/common";
import { createEffect, Actions, ofType } from "@ngrx/effects";
import { map, switchMap, tap } from "rxjs/operators";
import { GoAction, NavigateToAnamneseWithSelectedPatientAction, RouterActionTypes } from "../actions/actions";
import { PatientSelectedAction } from "libs/anamnese/src/lib/store/anamnese.actions";
import { concat, of } from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class RouterEffects {
	private actions$ = inject(Actions);
	private router = inject(Router);
	private location = inject(Location);


	navigate$ = createEffect(() => this.actions$.pipe(
		ofType(RouterActionTypes.GoAction),
		map((action: GoAction) => action.payload),
		tap(({ path, query: queryParams, extras }) =>
			this.router.navigate(path, { queryParams, ...extras })
		)
	), { dispatch: false });

	navigateToSignIn$ = createEffect(() => this.actions$.pipe(
		ofType(RouterActionTypes.GoSignInFromNoHttpAuthAction),
		map((action: GoAction) => action.payload),
		tap(({ path }) =>
			this.router.navigate(path)
		)
	), { dispatch: false });

	navigateToAnamnese$ = createEffect(() => this.actions$.pipe(
		ofType(RouterActionTypes.NavigateToAnamneseWithSelectedPatient),
		map((action: NavigateToAnamneseWithSelectedPatientAction) => action.id),
		switchMap((id: string) => {
			const extras: NavigationExtras = {
				info: {patientId: id}
			}
			return concat(
				of(new PatientSelectedAction(id)),
				of(new GoAction({path: ['/anamnese'], extras: extras}))
			)
		})
		)
	);

	navigateBack$ = createEffect(() => this.actions$.pipe(
		ofType(RouterActionTypes.BackAction),
		tap(() => this.location.back())
	), { dispatch: false });


	navigateForward$ = createEffect(() => this.actions$.pipe(
		ofType(RouterActionTypes.ForwardAction),
		tap(() => this.location.forward())
	), { dispatch: false });
}
